// frontend/src/pages/CadeauxRecusPage.js

import React, { useEffect, useState } from "react";
import API from "../axiosInstance";
import "../styles/CadeauxRecusPage.css";

function CadeauxRecusPage() {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGifts = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("currentUser"));
        if (!storedUser || !storedUser.email) {
          setLoading(false);
          return;
        }

        const res = await API.get(`/gifts/received/${storedUser.email}`);
        setGifts(res.data || []);
      } catch (err) {
        console.error("Erreur chargement cadeaux reçus :", err);
      } finally {
        setLoading(false);
      }
    };

    loadGifts();
  }, []);

  const totalGifts = gifts.length;

  const totalCoins = gifts.reduce(
    (sum, g) => sum + Number(g.coin_cost || 0),
    0
  );

  const eurosBruts = totalCoins * 0.01;
  const eurosNets = (eurosBruts * 0.8).toFixed(2);

  if (loading) {
    return <div className="cadeaux-page">Chargement…</div>;
  }

  return (
    <div className="cadeaux-page">
      <h1 className="cadeaux-title">🎁 Cadeaux reçus</h1>

      {/* ================= STATS ================= */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">NOMBRE DE CADEAUX</div>
          <div className="stat-value">{totalGifts}</div>
          <div className="stat-sub">
            Cadeaux reçus récemment
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-label">VALEUR TOTALE</div>
          <div className="stat-value">{totalCoins} coins</div>
          <div className="stat-sub">
            Somme de tous les cadeaux
          </div>
        </div>

        <div className="stat-card stat-green">
          <div className="stat-label">GAINS RÉELS</div>
          <div className="stat-value">{eurosNets} €</div>
          <div className="stat-sub">
           
          </div>
        </div>
      </div>

      {/* ================= LISTE ================= */}
      <h2 className="section-title">Derniers cadeaux</h2>

      <div className="gifts-row">
        {gifts.length === 0 && (
          <div className="empty">Aucun cadeau reçu</div>
        )}

        {gifts.map((gift) => (
          <div key={gift.id} className="gift-card">
            <div className="gift-name">{gift.name}</div>
            <div className="gift-coins">{gift.coin_cost} coins</div>
            <div className="gift-from">
              par @{gift.sender_pseudo || "inconnu"}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CadeauxRecusPage;
